// extracted by mini-css-extract-plugin
module.exports = {"container":"info-pop-up_container__ETXHT","close-btn":"info-pop-up_close-btn__29-ZO"};